import { notification } from 'antd'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { ApiParams } from '@types'

import { CarriersApi } from '../useCarriers/api'

interface useCarriersViewProps extends ApiParams {}

const useCarriersView = ({ filters }: useCarriersViewProps) => {
  const { t } = useTranslation()

  const { data, isLoading } = useQuery(
    [QUERY_KEYS.CARRIERS_ADMIN, filters],
    () => CarriersApi.getCarriersWithFilters({ filters }),
    {
      staleTime: Infinity,
      onError: () => {
        notification.error({
          message: t('globals.generics.carriers_error'),
        })
      },
    },
  )

  return {
    carriers: data,
    isLoading,
  }
}

export { useCarriersView }
